export type Category = {
  slug: string;
  name: string;
  tagline: string;
  desc: string;
  icon: string;
  color: "primary" | "accent" | "secondary";
  total: number;
};

export const categories: Category[] = [
  {
    slug: "exclusive",
    name: "独家猛料",
    tagline: "先于全网",
    desc: "拿到第一手材料后优先发布，每一条都附上信息来源与时间线，拒绝道听途说。",
    icon: "ri-fire-line",
    color: "primary",
    total: 128,
  },
  {
    slug: "investigation",
    name: "内幕调查",
    tagline: "交叉验证",
    desc: "从公开信息、多方信源与节点时间线交叉比对，还原事件背后真正的推动力。",
    icon: "ri-search-eye-line",
    color: "accent",
    total: 86,
  },
  {
    slug: "gossip",
    name: "微八卦",
    tagline: "细节读心",
    desc: "从一张路透、一次站位、一句采访口误里，读出行业里不肯明说的微表情。",
    icon: "ri-chat-smile-2-line",
    color: "secondary",
    total: 213,
  },
  {
    slug: "flash",
    name: "首发快讯",
    tagline: "快短准",
    desc: "一线动态第一时间触达，短句成稿、要点优先，让你比热搜早一步知道。",
    icon: "ri-flashlight-line",
    color: "primary",
    total: 342,
  },
  {
    slug: "depth",
    name: "深度长文",
    tagline: "慢下来读",
    desc: "主题长文与人物特稿，用完整叙事回答「为什么」，而不是只告诉你「发生了什么」。",
    icon: "ri-article-line",
    color: "accent",
    total: 64,
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((item) => item.slug === slug);